<script>
  import { onMount } from "svelte";
  import {
    formatPhone,
    formatTime,
    createdAt,
    waited,
    isRtl,
  } from "../utils.js";
  import CartItem from "./CartItem.svelte";

  import FaPhoneAlt from "svelte-icons/fa/FaPhoneAlt.svelte";
  import TiBackspace from "svelte-icons/ti/TiBackspace.svelte";
  import { showPopup, loading } from "../stores.js";

  import * as OrderDAL from "../dal/order-dal";
  import * as UserDAL from "../dal/user-dal";

  import FaExclamationCircle from "svelte-icons/fa/FaExclamationCircle.svelte";

  export let order;
  export let idx;
  export let showDetails = true;

  let isOpen = false;
  let dir = false;
  let detailsDiv;

  $: {
    if (order) {
      dir = isRtl(order.businessTitle) ? "rtl" : "ltr";
    }
  }

</script>

<div style={'direction:' + dir} class="item" class:odd={idx % 2 == 0}>
  <div
    class="row"
    on:click={() => {
      if (showDetails) {
        isOpen = !isOpen;
        if (isOpen) {
          detailsDiv.style.maxHeight = detailsDiv.scrollHeight + 'px';
        } else {
          detailsDiv.style.maxHeight = '0px';
        }
      }
    }}
  >
    {#if showDetails}
      <i class="arrow" class:up={isOpen} class:down={!isOpen} />
    {/if}
    <div class="orderId">{order.orderId}#</div>
    <div class="createdAt">{createdAt(order.createdAt)}</div>
    <div class="sum">{order.sum} ₪</div>
  </div>
  {#if showDetails}
    <div class="details" class:open={isOpen} bind:this={detailsDiv}>
      <div class="items">
        {#each order.items as item}
          <CartItem {item} itemStyle={'closed'} />
        {/each}
      </div>
      <div class="leftSide">
        {#if order.createdAt && order.closedAt}
          <div class="waited">
            <object
              type="image/svg+xml"
              class="clock"
              data="images/clock_icon.svg"
              alt="clock icon"
              title="clock icon"
            />
            זמן המתנה:
            {' ' + waited(order.createdAt, order.closedAt)}
          </div>
        {:else if order.refunded}
          <div class="refunded">
            <div class="refundedIcon">
              <TiBackspace />
            </div>
            הזמנה בוטלה:
            {createdAt(order.createdAt)}
          </div>
        {/if}
        {#if order.phoneNumber}
          <a href="tel:{order.phoneNumber}">
            <div class="phoneNumber">
              <span><FaPhoneAlt /></span>
              {formatPhone(order.phoneNumber)}
            </div>
          </a>
        {/if}
        {#if !order.refunded}
          <div
            class="cancleOrder"
            on:click={async () => {
              showPopup('האם אתה בטוח?', async () => {
                try {
                  $loading = true;
                  await OrderDAL.cancelAndRefund(order.id, '');
                  $loading = false;
                } catch (e) {
                  $loading = false;
                  showPopup('...משהו השתבש', () => {});
                  UserDAL.sendLog('cancel and refund', e.toString());
                }
              });
            }}
          >
            <div class="cancleIcon">
              <FaExclamationCircle />
            </div>
            בטל הזמנה
          </div>
        {:else}
          <div class="orderCancled">ההזמנה בוטלה</div>
        {/if}
      </div>
    </div>
  {/if}
</div>

<style>
  .cancleIcon {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
  }
  .cancleOrder {
    background: var(--red1);
    color: white;
    padding: 5px;
    border-radius: 4px;
    margin: 20px 7px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 6px 10px 6px 14px;
  }

  .orderCancled {
    color: var(--red1);
    background: white;
    padding: 5px;
    border-radius: 6px;
    margin: 20px 7px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 6px 14px 6px 14px;
    border: 3px dashed;
  }

  .refunded {
    display: flex;
    align-items: center;
  }

  .refundedIcon {
    width: 25px;
    max-height: 25px;
    margin-left: 5px;
    color: var(--red1);
  }

  .phoneNumber {
    display: flex;
    align-items: center;
    line-height: 14px;
    margin-top: 18px;
  }

  .phoneNumber span {
    width: 18px;
    display: inline-block;
    margin-left: 5px;
    margin-right: 6px;
  }

  .item {
    font-size: 14px;
  }

  .items {
    padding: 10px 5px 10px 10px;
    border: 3px dashed #d2d2d2;
    border-radius: 5px;
    margin: 5px;
    margin-bottom: 20px;
    margin-right: 10px;
  }

  .row {
    display: flex;
    align-items: center;
    min-height: 30px;
    padding: 5px;
    box-sizing: border-box;
  }

  .details {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.15s ease-out;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .details.open {
    max-height: 500px;
  }

  .arrow {
    margin: 15px;
    border: solid #898887;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
  }

  .down {
    transform: rotate(45deg);
  }

  .up {
    transform: rotate(-135deg);
  }

  .odd {
    background: #f0f0f0;
    border-radius: 5px;
  }

  .orderId {
    margin-left: 10px;
  }

  .sum {
    margin-left: 10px;
    margin-right: auto;
  }

  .leftSide {
    padding: 10px;
  }

  .waited {
    padding: 5px;
    border-radius: 30px;
    display: inline-flex;
    align-items: center;
    /* border: 2px solid #2fb738; */
    padding-left: 18px;
  }

  .clock {
    width: 18px;
    display: inline-block;
    margin-left: 5px;
  }

</style>
